/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespAboutModule_viewer = {
    readonly isDyoEnabled: boolean | null;
    readonly " $refType": "PdpRespAboutModule_viewer";
};
export type PdpRespAboutModule_viewer$data = PdpRespAboutModule_viewer;
export type PdpRespAboutModule_viewer$key = {
    readonly " $data"?: PdpRespAboutModule_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespAboutModule_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutModule_viewer",
  "selections": [
    {
      "alias": "isDyoEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "designYourOwn"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"designYourOwn\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '29a5474102a05a4cdc530e0218acfe4d';
export default node;
